import { FONTS } from '../../tokens/fonts';

export type TControlSize = 'S' | 'XS' | 'XXS';
export type TControlDirection = 'left' | 'right';

interface ISizeProps {
    inputSize: number,
    radioCheckSize: number,
    font: string,
    rMargin: number,
}

interface ICheckboxSizeProps extends ISizeProps {
    iconWidth: number,
    iconHeight: number,
    promoIconSize: number,
}

type ICheckboxSizes = {
    [key in TControlSize]: Partial<ICheckboxSizeProps>;
}

export const getSizes = (size: TControlSize, data: ICheckboxSizes): Partial<ICheckboxSizeProps> => data[size];

export const checkboxSizes: ICheckboxSizes = {
    S: {
        inputSize: 24,
        font: FONTS.MediumS,
        rMargin: 12,
        iconWidth: 13,
        iconHeight: 9,
        promoIconSize: 11,
    },
    XS: {
        inputSize: 20,
        font: FONTS.MediumXS,
        rMargin: 8,
        iconWidth: 11,
        iconHeight: 7,
        promoIconSize: 9,
    },
    XXS: {
        inputSize: 16,
        font: FONTS.MediumXXS,
        rMargin: 8,
        iconWidth: 9,
        iconHeight: 6,
        promoIconSize: 7,
    },
};

export const radioSizes: ICheckboxSizes = {
    S: {
        inputSize: 24,
        radioCheckSize: 10,
        font: FONTS.MediumS,
        rMargin: 12,
    },
    XS: {
        inputSize: 20,
        radioCheckSize: 8,
        font: FONTS.MediumXS,
        rMargin: 8,
    },
    XXS: {
        inputSize: 16,
        radioCheckSize: 6,
        font: FONTS.MediumXXS,
        rMargin: 8,
    },
};
